import { Display } from "../../../Models/Display";

export const responsiveParcels = (display?: Display) => {
  return {
    cells: {
      internalReference: { gridArea: "internalReference" },
      width: { gridArea: "width" },
      length: { gridArea: "length" },
      height: { gridArea: "height" },
      weight: { gridArea: "weight" },
      volume: { gridArea: "volume" },
      totalQuantity: { gridArea: "totalQuantity" },
      totalWeight: { gridArea: "totalWeight" },
      totalVolume: { gridArea: "totalVolume" },
    },

    // GRID Header
    header: {
      display: "grid",
      gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr",
      gridTemplateAreas: ` 
      "internalReference width length height weight volume "
    `,
    },

    // GRID ListItem
    listItem: {
      display: "grid",
      gridTemplateColumns: display?.xs
        ? "1fr"
        : display?.sm
          ? "1fr 1fr"
          : display?.md
            ? "1fr 1fr 1fr"
            : "2fr 1fr 1fr 1fr 1fr 1fr",

      gridTemplateAreas: display?.xs
        ? `
      "internalReference"
      "width"
      "length"
      "height"
      "weight"
      "volume"
    `
        : display?.sm
          ? `
      "internalReference internalReference"
      "width length"
      "height weight"
      "volume volume"
    `
          : display?.md
            ? `
      "internalReference weight volume"
      "width length height"
    `
            : `
      "internalReference width length height weight volume"
    `,
    },

    // GRID Footer
    footer: {
      display: "grid",
      gridTemplateColumns: display?.xs
        ? "1fr"
        : display?.sm
          ? "1fr 1fr"
          : display?.md
            ? "1fr 1fr 1fr"
            : "2fr 1fr 1fr 1fr 1fr 1fr",

      gridTemplateAreas: display?.xs
        ? `
      "totalQuantity"
      "totalWeight"
      "totalVolume"
    `
        : display?.sm
          ? `
      "totalQuantity totalQuantity"
      "totalWeight totalVolume"
    `
          : display?.md
            ? `
      "totalQuantity totalWeight totalVolume"
    `
            : `
      ". . . totalQuantity totalWeight totalVolume"
    `,
    },
  };
};
